





































































































































































































// eslint-disable
import Vue from "vue";
import Password from "../components/Password.vue";
import API from "../services/api";
import { ParticipantResult } from "../services/participante";
import { mapState } from "vuex";
import ConfRegistroParticipante from "../components/ConfRegistroparticipante.vue";
import Registrado from "../components/Registrado.vue";

interface Data {
  id_participante: string;
  nombres: string;
  apellidos: string;
  dni: string;
  email: string;
}

export default Vue.extend({
  components: {
    Password,
    ConfRegistroParticipante,
    Registrado,
  },

  data: () => ({
    email: "",
    confMail: "",
    nameRules: [
      (v: any) => !!v || "El nombre es requerido",
      (v: any) =>
        /^[A-Z ]+$/i.test(v) || "Solo puede ingresar caracteres alfabéticos",
    ],
    lastNameRules: [
      (v: any) => !!v || "El apellido es requerido",
      (v: any) =>
        /^[A-Z ]+$/i.test(v) || "Solo puede ingresar caracteres alfabéticos",
    ],
    institucionRules: [(v: any) => !!v || "Campo necesario"],
    programaRules: [(v: any) => !!v || "Campo necesario"],
    dniRules: [(v: any) => !!v || "Campo necesario"],
    emailRules: [
      (v: any) => !!v || "E-mail es requerido",
      (v: any) =>
        /^\S+?@(?:[^\s.]+\.)+[^\s.]{2,}$/.test(v) ||
        "Dirección de correo no válida",
    ],
    telRules: [(v: any) => !!v || "Campo necesario"],
    encontrado: false,
    findPass: false,
    select: null,
    checkbox: false,
    page: 1,
    nombres: "",
    apellidos: "",
    telefono: "",
    institucion: "",
    programa: "",
    dni: null,
    pass: "",
    valid: true,
    error: false,
    id_participante: null,
    valid2: false,
    otro: false,
    auxins: "",
    mostrarInfo: false,
    selectRegistro: false,
    tipo: 1,
    data: {} as Data,
    alerta: false,
  }),

  computed: {
    ...mapState("registro", ["instituciones"]),

    matchEmail() {
      return (
        (/^\S+?@(?:[^\s.]+\.)+[^\s.]{2,}$/.test(this.confMail) &&
          this.email === this.confMail) ||
        "Los correos no coinciden"
      );
    },

    datos() {
      let pos_admin = false;
      if (this.tipo == 2) {
        pos_admin = true;
      }
      return {
        nombres: this.nombres,
        apellidos: this.apellidos,
        institucion: this.institucion,
        programa: this.programa,
        dni: this.dni,
        email: this.email.toLocaleLowerCase(),
        pass: this.pass,
        id_participante: this.id_participante,
        telefono: this.telefono,
        pos_admin,
      };
    },
    evaluadorRegistrado: {
      get() {
        return this.tipo === 2 && this.findPass;
      },
      set(value: any) {
        this.tipo = value;
      },
    },
  },

  methods: {
    change(evt: any) {
      if (evt == "Otra") {
        this.otro = true;
      } else {
        this.institucion = this.auxins;
      }
    },

    async actualizarEva(data: any) {
      const result: ParticipantResult = await this.$store.dispatch(
        "participant/setEvaluador",
        {
          data,
          componente: this,
        }
      );
      if (!result) {
        return;
      }
    },

    async save() {
      if (this.encontrado && !this.findPass) {
        const result: ParticipantResult = await this.$store.dispatch(
          "participant/setAutorPass",
          {
            data: (this as any).datos,
            componente: this,
          }
        );
        if (!result) {
          return;
        }
      } else {
        const result: ParticipantResult = await this.$store.dispatch(
          "participant/autorPass",
          {
            data: (this as any).datos,
            componente: this,
          }
        );
        if (!result) {
          return;
        }
      }
    },

    onPaste(evt: any) {
      evt.preventDefault();
    },

    guardar() {
      (this as any).save();
    },

    search() {
      API.getRequest(`/participante/${this.dni}`)
        .then((resp) => {
          const data = resp.data;
          if (resp.data) {
            if (data.pass && data.pos_admin) {
              this.alerta = true;
              this.evaluadorRegistrado = 0;
            }
            if (data.pass) {
              this.data.id_participante = data.id_participante;
              this.data.dni = data.dni;
              this.data.nombres = data.nombres;
              this.data.apellidos = data.apellidos;
              this.data.email = data.email;
              this.findPass = true;
              this.alerta = true;
              this.valid = false;
            } else {
              this.encontrado = true;
              this.dni = data.dni;
              this.nombres = data.nombres;
              this.apellidos = data.apellidos;
              this.email = data.email;
              this.programa = data.programa;
              this.institucion = data.institucion;
              this.id_participante = data.id_participante;
              this.telefono = data.telefono;
              this.auxins = data.institucion;
            }
          }
        })
        .catch(() => {
          (this as any).clearAll();
        });
    },

    clearAll(dni?: any) {
      this.nombres = "";
      this.apellidos = "";
      this.institucion = "";
      this.programa = "";
      this.email = "";
      this.pass = "";
      if (dni) {
        (this as any).dni = "";
      }
      this.telefono = "";
    },
  },
});
